document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-checkout-items-form]');
  if (!form) return;

  const checkoutButton = document.querySelector(
    '[data-checkout-items-checkout]'
  );
  if (checkoutButton) {
    checkoutButton.addEventListener('click', (e) => {
      setLoading();
      checkoutButton.setAttribute('disabled', true);
    });
  }

  const setLoading = () => {
    // form.classList.add('loadable');
    // form.classList.add('is-loading');
  };

  const QTY_SUBMIT_DELAY = 500;
  let qtySubmitTimer = null;

  const submitForm = () => {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    setLoading();
    form.submit();
  };

  const debouncedSubmitForm = () => {
    clearTimeout(qtySubmitTimer);
    qtySubmitTimer = setTimeout(submitForm, QTY_SUBMIT_DELAY);
  };

  // clear the cart
  const clearCartButton = form.querySelector('[data-checkout-clear-cart]');
  if (clearCartButton) {
    clearCartButton.addEventListener('click', (e) => {
      e.preventDefault();
      clearTimeout(qtySubmitTimer);
      form
        .querySelectorAll('[data-checkout-item-remove] input[type="hidden"]')
        .forEach((input) => {
          input.value = '1';
        });
      submitForm();
    });
  }

  // remove an item from the cart
  form.querySelectorAll('[data-checkout-item-remove]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      clearTimeout(qtySubmitTimer);
      const input = el.querySelector('input[type="hidden"]');
      input.value = '1';
      submitForm();
    });
  });

  // update the quantity of an item
  form.querySelectorAll('[data-checkout-item-qty]').forEach((el) => {
    el.addEventListener('change', (e) => {
      e.preventDefault();
      debouncedSubmitForm();
    });
  });

  // on form submit, add a class 'is-loading'
  form.addEventListener('submit', () => {
    setLoading();
  });
});
